<template>
  <div>
    <BundleSelection
      :title="computedTitle"
      :description="computedDescription"
      :buttons="computedButtons"
      @bundle-selected="isOwner ? showSinoaSelection = true : null"
    />
    <SinoaSelection
      v-if="showSinoaSelection"
      @close="showSinoaSelection = false"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import BundleSelection from './BundleSelection.vue';
import { COLORS } from '@/helpers/colors';
import SinoaSelection from '@/pages/chatbot/SinoaSelection.vue';

export default {
  name: 'PaywallForPaidUsers',

  components: {
    BundleSelection,
    SinoaSelection,
  },

  data() {
    return {
      COLORS,
      showSinoaSelection: false,
    };
  },

  computed: {
    ...mapGetters('permissions', ['isOwner']),
    ...mapState('subscription', ['ownerPhone']),

    computedTitle() {
      return this.isOwner ? 'Need more Questions?' : 'Out of Questions?';
    },

    computedDescription() {
      if (this.isOwner) {
        return [
          'They’ll be added to your account right away and will ',
          '<strong>automatically top up</strong>',
          ' when you run out (you can turn this off during checkout).',
          '<br>Click Buy Questions to top up and keep the answers coming.',
        ].join('');
      }
      return 'Ask your account owner to add more Sinoa Questions so you can keep using Sinoa.';
    },

    computedButtons() {
      if (this.isOwner) {
        return [{
          buttonText: 'Buy Questions',
          action: () => this.$emit('checkout'),
          color: this.COLORS.grainfoxAIButton,
        }];
      }
      const buttons = [{
        buttonText: 'Email Account Owner',
        action: () => this.$emit('email-contact-owner'),
        color: this.COLORS.grainfoxAIButton,
      }];
      if (this.ownerPhone) {
        buttons.push({
          buttonText: 'Message Account Owner',
          action: () => this.$emit('message-account-owner'),
          color: this.COLORS.primary,
        });
      }
      return buttons;
    },
  },
};
</script>
